import {Container, SafeAreaSpacer, Tab, TabName} from './styles';
import {ReactComponent as Recipes} from 'assets/img/recipes.svg';
import {ReactComponent as Articles} from 'assets/img/articles.svg';
import {ReactComponent as Home} from 'assets/img/home.svg';
import {ReactComponent as Gifts} from 'assets/img/gifts.svg';
import {ReactComponent as Profile} from 'assets/img/profile.svg';

const Tabs = () => (
  <>
    <SafeAreaSpacer />
    <Container>
      <Tab
        activeClassName="active"
        exact
        to="/"
        isActive={(match, {pathname}) => ['/', '/login'].includes(pathname)}>
        <Home />
        <TabName>Accueil</TabName>
      </Tab>

      <Tab activeClassName="active" exact to="/gifts">
        <Gifts />
        <TabName>Cadeaux</TabName>
      </Tab>

      <Tab
        exact
        to="/recipes"
        activeClassName="active"
        isActive={(match, {pathname}) => pathname.startsWith('/recipe')}>
        <Recipes />
        <TabName>Recettes</TabName>
      </Tab>

      <Tab
        activeClassName="active"
        exact
        to="/articles"
        isActive={(match, {pathname}) => pathname.startsWith('/articles')}>
        <Articles />
        <TabName>Articles</TabName>
      </Tab>

      <Tab activeClassName="active" exact to="/profile">
        <Profile />
        <TabName>Profil</TabName>
      </Tab>
    </Container>
  </>
);
export default Tabs;
